module.exports = __webpack_public_path__ + "static/media/nishiwaki_button_gochirameru.e74e409d.png";